import React from 'react';
import sponsoredProductsPropType from './sponsoredProductsPropType';

export default (BaseComponent) => {
  const displayName =
    BaseComponent.displayName || BaseComponent.name || 'Component';

  function saveCountToDataLayer(sponsoredProducts) {
    const totalSponsoredProducts = (sponsoredProducts.length > 3
      ? sponsoredProducts.length : 0) || 0;
    window.appState.dispatch({
      type: 'COUNT_SPONSORED_PRODUCTS',
      payload: totalSponsoredProducts
    });
  }

  function saveProductsToDataLayer(products) {
    window.appState.dispatch({
      type: 'ADD_SPONSORED_PRODUCTS',
      payload: products
    });
  }

  class withDataLayer extends React.PureComponent {
    componentDidMount() {
      const sponsoredProducts = this.getSponsoredProducts();
      if (sponsoredProducts) {
        saveCountToDataLayer(sponsoredProducts);
        saveProductsToDataLayer(sponsoredProducts);
      }
    }

    getSponsoredProducts() {
      if (this.props.rowProductsList && this.props.rowProductsList.length &&
        this.props.rowProductsList.length > 0) {
        return this.props.rowProductsList;
      }

      return this.props.productsList || [];
    }

    render() {
      return (
        <BaseComponent {...this.props} />
      );
    }
  }

  withDataLayer.displayName =
    `withDataLayer(${displayName})`;
  withDataLayer.propTypes = {
    rowProductsList: sponsoredProductsPropType,
    productsList: sponsoredProductsPropType
  };

  withDataLayer.defaultProps = {
    rowProductsList: null,
    productsList: null
  };

  return withDataLayer;
};

